import { CommonModule } from '@angular/common';
import { booleanAttribute, Component, computed, inject, input, output, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { IdGeneratorPipe } from '../../pipes/id-generator.pipe';
import { IconSanitizerService } from '../../services/icon-sanitizer.service';

@Component({
    selector: 'lib-badge',
    templateUrl: './badge.component.html',
    styleUrls: ['./badge.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, IdGeneratorPipe, RouterModule]
})
export class BadgeComponent<T extends { isActive?: boolean; route?: string }> {
    label = input<string>();

    text = input<T | string>();

    key = input<keyof T>();

    removeButton = input(false, { transform: booleanAttribute });

    color = input<'primary' | 'secondary' | 'tertiary' | 'quaternary'>('primary');

    readonly = input(false, { transform: booleanAttribute });

    badgeId = input<string>();

    item = input<T>();

    readonly removeItem = output<T>();

    private readonly iconSanitizer = inject(IconSanitizerService);

    readonly closeIcon: SafeHtml = this.iconSanitizer.getIcon('close');

    normalizedPath = computed(() => {
        const path = this.item()?.route;

        if (!path) return undefined;

        return path.startsWith('/') ? path : `/${path}`;
    });

    displayValue = computed(() => {
        const item = this.item();
        const key = this.key();

        if (item && key) return item[key];

        return this.text();
    });

    classColor = computed(() => {
        const color = this.color();
        switch (color) {
            case 'primary':
                return 'primaryColor';
            case 'secondary':
                return 'secondaryColor';
            case 'tertiary':
                return 'tertiaryColor';
            case 'quaternary':
                return 'quaternaryColor';
            default:
                return '';
        }
    });

    remove(event: Event): void {
        event.stopPropagation();
        const item = this.item();
        if (item !== undefined) this.removeItem.emit(item);
    }
}
